import React, { Component } from 'react';
import PropTypes from 'prop-types';

class PayjpCheckout extends Component {
  constructor(props) {
    super(props);
  }

  static defaultProps = {
    partial: true,
  };

  static propTypes = {
    apiKey: PropTypes.string.isRequired,
    payjp: PropTypes.string,
    partial: PropTypes.bool,
    text: PropTypes.string,
    submitText: PropTypes.string,
    tokenName: PropTypes.string,
    previousToken: PropTypes.string,
    lang: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
  };

  componentDidMount() {
    const { apiKey, payjp, partial, text, submitText, tokenName, previousToken, lang, placeholder } = this.props;
    window.reactPayjpCheckoutOnCreated = this.onCreated;
    window.reactPayjpCheckoutOnFailed = this.onFailed;
    this.windowAlertBackUp = window.alert;
    window.alert = () => {};
    const script = document.createElement('script');
    script.setAttribute('src', 'https://checkout.pay.jp/');
    script.setAttribute('data-on-created', 'reactPayjpCheckoutOnCreated');
    script.setAttribute('data-on-failed', 'reactPayjpCheckoutOnFailed');
    script.setAttribute('data-key', apiKey);
    script.setAttribute('class', 'payjp-button');
    payjp && script.setAttribute('data-payjp', payjp);
    partial && script.setAttribute('data-partial', partial);
    text && script.setAttribute('data-text', text);
    submitText && script.setAttribute('data-submit-text', submitText);
    tokenName && script.setAttribute('data-token-name', tokenName);
    previousToken && script.setAttribute('data-previous-token', previousToken);
    lang && script.setAttribute('data-lang', lang);
    placeholder && script.setAttribute('data-name-placeholder', placeholder);
    this.script = script;
    this.payjpCheckoutRef && this.payjpCheckoutRef.appendChild(this.script);
  }

  componentWillUnmount() {
    this.payjpCheckoutRef && this.script && this.payjpCheckoutRef.removeChild(this.script);
    window.reactPayjpCheckoutOnCreated = null;
    window.reactPayjpCheckoutOnFailed = null;
    window.alert = this.windowAlertBackUp;
    window.PayjpCheckout = null;
  }

  shouldComponentUpdate() {
    return false;
  }

  onCreated = response => {
    this.props.onCreated(response);
  };

  onFailed = (statusCode, errorResponse) => {
    this.props.onFailed(statusCode, errorResponse);
  };

  render() {
    return <div ref={node => (this.payjpCheckoutRef = node)} className={this.props.className} />;
  }
}

export default PayjpCheckout;
